/* @ngInject */
export function timerDirective (Timer, $filter) {
	return {
		restrict: 'A',
		link (scope, element, attrs) {
			const formatTime = $filter('ng1FormatTime');

			// the timer
			const timer = Timer.get(attrs.id);
			timer.on('time', function (time) {
				element.text(formatTime(time));
			});

			// set initial text
			element.text(formatTime(timer.getTime()));

			// watch for input change
			scope.$watch(attrs.uiTimer, function (value) {
				if (value) {
					timer.start();
				} else {
					timer.pause();
				}
			});
		}
	};
}
